import { action } from 'satcheljs';

/**
 * This action starts the mail search session and initializes things for 3s mail search.
 * It should be fired once, on the start of first search.
 */
const startMailSearchSession = action('startMailSearchSession');

/**
 * This action ends the mail search session.
 * It should be fired only once when exiting the search module
 */
const endMailSearchSession = action('endMailSearchSession');

/**
 * This action starts the mail search every time a query is submitted.
 * It triggers executeSearch action after loading the tableView
 */
const startMailSearch = action('startMailSearch');

/**
 * This action is triggered whenever a folder scope change happens
 */
const switchMailSearchFolderScope = action(
    'switchMailSearchFolderScope',
    (folderScopeId?: string) => ({ folderScopeId })
);

const resetMailSearchStore = action('resetMailSearchStore');

export {
    startMailSearchSession,
    endMailSearchSession,
    startMailSearch,
    switchMailSearchFolderScope,
    resetMailSearchStore,
};
